import React, { useState } from "react";
import BracketButton from "../bracketButton/bracketButton";
import ModalContainer from "../modalContainer/modalContainer";
import FaSpinner from "../faSpinner/faSpinner";
import ChangeSubscriptionStatus from "../changeSubscriptionStatus/changeSubscriptionStatus";
import v4 from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import useApiProducts from "../../customHooks/useApiProducts";
import ReactTable from "../reactTable";
import { useSelector } from "react-redux";
import StatusMessage from "../statusMessage/statusMessage";
import "./styles.css";

const SubscribeProductToApp = (props) => {
  const { subscriptions, applicationId } = props;
  const {
    apiProducts,
    isLoading,
    subscribeApiProduct,
    errorMessage,
    clearError,
  } = useApiProducts(applicationId);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  let loadingApp = useSelector(({ application }) => application.loading);

  const products = (apiProducts) =>
    apiProducts
      ? apiProducts.map((product) => ({
          ...product,
          subscribed: !!subscriptions.map((s) => s.uuid).includes(product.uuid),
        }))
      : [];

  const productToSubscribe = (subscribed, productId) => {
    // Clear any existing errors when performing new action
    clearError();

    const data = {
      type: subscribed ? "unsubscribe" : "subscribe",
      application: applicationId,
      product: productId,
    };

    setSelectedProduct(productId);
    subscribeApiProduct.mutate(data);
  };
  const tableData = React.useMemo(
    () => products(apiProducts),
    [apiProducts, subscriptions]
  );
  const columns = React.useMemo(
    () => [
      {
        header: "Image",
        accessorKey: "image",
        cell: ({ getValue }) => {
          const value = getValue();
          return <img style={{ width: "50px" }} src={value?.url} />;
        },
      },
      {
        header: "Name",
        accessorKey: "title",
      },
      {
        header: "Status",
        accessorKey: "subscribed",
        cell: function ChangeStatus({ row }) {
          const { uuid, subscribed } = row.original;

          return (
            <div className="cell">
              <ChangeSubscriptionStatus
                button
                withIcon
                circleIcon
                loading={
                  (subscribeApiProduct.isLoading || loadingApp) &&
                  selectedProduct === uuid
                }
                subscribed={subscribed}
                changeSubscriptionStatus={() =>
                  productToSubscribe(subscribed, uuid)
                }
              />
            </div>
          );
        },
      },
      {
        header: "Details",
        accessorKey: "alias",
        cell: function Navigate({ getValue, row }) {
          const alias = getValue();
          const productId = row.original.uuid;
          // Ensure we have a proper path - use alias if available, otherwise use uuid
          const path = alias || `/apiProduct/${productId}`;
          return (
            <Link key={v4()} to={path}>
              <FontAwesomeIcon icon={faInfoCircle} />
              <span style={{ marginLeft: "12px" }}>{"View Details"}</span>
            </Link>
          );
        },
      },
    ],

    [loadingApp, subscribeApiProduct.isLoading, selectedProduct]
  );

  if (isLoading) {
    return <FaSpinner loading />;
  }

  return (
    <>
      <BracketButton
        caretEnable
        moving
        title="Subscribe Here"
        movingBrackets
        onClick={() => setOpenDialog(true)}
      />

      <ModalContainer
        isOpen={openDialog}
        closeModal={() => {
          setOpenDialog(false);
          clearError(); // Clear error when closing modal
        }}
        contentLabel="Subscribe Modal"
        title="Select Product"
        className="client-select-popup-modal subscribe-product-to-app"
      >
        <React.Fragment>
          <ReactTable
            data={tableData}
            columns={columns}
            headerColumnClass={"table-header-column-default"}
          />
          {errorMessage && (
            <div style={{ marginTop: 20 }}>
              <StatusMessage modifiers={[StatusMessage.ERROR]}>
                {errorMessage}
              </StatusMessage>
            </div>
          )}
        </React.Fragment>
      </ModalContainer>
    </>
  );
};

export default SubscribeProductToApp;
